module.exports = __webpack_public_path__ + "img/2_half.6b5f0b5c.png";